import { createContext } from 'react';
import { User, Session } from '@supabase/supabase-js';

export interface ActiveDevice {
  id: string;
  device_info: { name: string; type: string };
  last_active: string;
}

export interface VerificationData {
  email: string;
  deviceFingerprint: string;
}

export interface SignInResult {
  error: Error | null;
  requiresForceLogin?: boolean;
  activeDevices?: ActiveDevice[];
  requiresVerification?: boolean;
  verificationData?: VerificationData;
  tempSession?: Session;
  requiresSubscription?: boolean;
  userEmail?: string;
}

export interface SignUpResult {
  error: Error | null;
}

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  userRole: 'admin' | 'user' | null;
  userProfile: { first_name?: string; last_name?: string } | null;
  loading: boolean;
  signIn: (email: string, password: string, forceLogin?: boolean) => Promise<SignInResult>;
  signUp: (email: string, password: string, userData?: Record<string, unknown>) => Promise<SignUpResult>;
  signOut: () => Promise<void>;
  terminateAllSessions: () => Promise<void>;
  cleanupTempSession: () => Promise<void>;
  restoreSessionFromToken: (access_token: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
